import { useMutation } from "react-query";
import { PartnerApi } from "../../api/partner.api";
import { useOpportunitiesStore } from "../../store/opportunities.store";

export const useOpportunities = () => {
  const setOpportunities = useOpportunitiesStore(
    (state) => state.setOpportunities
  );

  return useMutation(PartnerApi.opportunities, {
    onSuccess: (data) => {
      setOpportunities(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};

export const useOpportunitiesCompanyDetail = () => {
  const setOpportunitiesCompanyDetail = useOpportunitiesStore(
    (state) => state.setOpportunitiesCompanyDetail
  );

  return useMutation(PartnerApi.opportunities, {
    onSuccess: (data) => {
      setOpportunitiesCompanyDetail(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};
